import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DateLocaleService } from '@core-formatting';

@Component({
  selector: 'fr8bot-root',
  template: `<router-outlet />`,
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private dateLocaleService = inject(DateLocaleService);
}
